(function () {
  if (window.KnowFitTestCatalogUI) return;
  const controls = new Set();
  const initialized = new WeakSet();
  const meals = { breakfast: 'Desayuno', main: 'Comida', snack: 'Merienda', dinner: 'Cena' };
  const partners = { breakfast: 'snack', snack: 'breakfast', main: 'dinner', dinner: 'main' };
  let busy = false;
  // Keep the entry point visible after clearing an import on this page.
  let visible = new URL(window.location.href).searchParams.get('knowfit_test') === '1'
    || Boolean(window.Shopify?.designMode);

  function setError(panel, message) {
    const node = panel.querySelector('[data-knowfit-test-error]');
    node.textContent = message;
    node.hidden = !message;
  }

  function render(panel) {
    const provider = window.KnowFitTestCatalog;
    const active = Boolean(provider?.isActive());
    visible ||= active;
    panel.hidden = !visible;
    panel.querySelector('[data-knowfit-test-clear]').hidden = !active;
    panel.querySelector('[data-knowfit-test-indicator]').textContent = active ? '· PRUEBA ACTIVA' : '';
    panel.querySelectorAll('button, input').forEach((input) => { input.disabled = busy; });
    const status = panel.querySelector('[data-knowfit-test-status]');
    const warnings = panel.querySelector('[data-knowfit-test-warnings]');
    warnings.replaceChildren();
    warnings.hidden = true;
    renderSources(panel, null);
    if (!active) {
      status.textContent = 'Fuente actual: colecciones configuradas.';
      return;
    }
    try {
      const record = provider.getRecord();
      const summary = record.summary;
      status.textContent = `Prueba activa: ${summary.product_count} productos, ${summary.valid_variant_count} variantes válidas de ${summary.variant_count}. Carrito bloqueado.`;
      renderSources(panel, record);
      const messages = [...(summary.warnings || [])];
      (summary.rejected || []).forEach((item) => messages.push(`${item.title || item.variant_id}: ${item.message}`));
      messages.forEach((message) => {
        const item = document.createElement('li');
        item.textContent = message;
        warnings.append(item);
      });
      warnings.hidden = !messages.length;
    } catch (error) {
      status.textContent = 'Prueba bloqueada. Usa «Volver a las colecciones» para borrar los datos guardados y después vuelve a adjuntar los ficheros.';
      panel.querySelectorAll('[data-knowfit-test-source]').forEach((node) => {
        node.textContent = 'No se puede leer la asignación guardada.';
      });
      setError(panel, error.message);
    }
  }

  function renderSources(panel, record) {
    Object.entries(meals).forEach(([mealType]) => {
      const assignment = record?.assignments?.[mealType];
      const effectiveSource = record?.catalog?.sources?.[mealType];
      const fallbackFrom = effectiveSource?.fallback_from;
      const sourceText = panel.querySelector(`[data-knowfit-test-source="${mealType}"]`);
      const removeButton = panel.querySelector(`[data-knowfit-test-remove="${mealType}"]`);
      removeButton.hidden = !assignment;
      if (assignment) {
        const title = assignment.summary?.collection?.title;
        sourceText.textContent = `Fichero propio: ${assignment.file_name}${title ? ` · ${title}` : ''} · ${assignment.summary?.valid_variant_count ?? 0} variantes válidas.`;
      } else if (fallbackFrom && record.assignments?.[fallbackFrom]) {
        sourceText.textContent = `Usa el fichero de ${meals[fallbackFrom]}: ${record.assignments[fallbackFrom].file_name}.`;
      } else {
        sourceText.textContent = `Sin asignar. Adjunta aquí o en ${meals[partners[mealType]]}.`;
      }
    });
  }

  function refresh() {
    controls.forEach((panel) => {
      if (panel.isConnected === false) { controls.delete(panel); return; }
      render(panel);
    });
  }

  async function load(panel) {
    if (busy) return;
    setError(panel, '');
    const files = Object.fromEntries(Array.from(panel.querySelectorAll('[data-knowfit-test-file]'))
      .filter((input) => input.files?.[0]).map((input) => [input.dataset.knowfitTestFile, input.files[0]]));
    if (!Object.keys(files).length) { setError(panel, 'Selecciona primero al menos un fichero JSON exportado.'); return; }
    busy = true;
    refresh();
    try {
      if (!window.KnowFitTestCatalog) throw new Error('No se ha cargado el importador. Recarga la página.');
      await window.KnowFitTestCatalog.importFiles(files);
      controls.forEach((control) => setError(control, ''));
      panel.querySelectorAll('[data-knowfit-test-file]').forEach((input) => { input.value = ''; });
    } catch (error) {
      setError(panel, error.message || 'No se pudo cargar el fichero.');
    } finally {
      busy = false;
      refresh();
    }
  }

  function clear(panel) {
    if (busy) return;
    try {
      window.KnowFitTestCatalog.clear();
      controls.forEach((control) => {
        setError(control, '');
        control.querySelectorAll('[data-knowfit-test-file]').forEach((input) => { input.value = ''; });
      });
      refresh();
    } catch (error) { setError(panel, error.message); }
  }

  function remove(panel, mealType) {
    if (busy) return;
    try {
      window.KnowFitTestCatalog.removeFile(mealType);
      controls.forEach((control) => {
        setError(control, '');
        control.querySelector(`[data-knowfit-test-file="${mealType}"]`).value = '';
      });
      refresh();
    } catch (error) { setError(panel, error.message); }
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-knowfit-test-controls]').forEach((panel) => {
      if (initialized.has(panel)) return;
      initialized.add(panel);
      controls.add(panel);
      panel.querySelector('[data-knowfit-test-load]').addEventListener('click', () => load(panel));
      panel.querySelector('[data-knowfit-test-clear]').addEventListener('click', () => clear(panel));
      panel.querySelectorAll('[data-knowfit-test-remove]').forEach((button) => {
        button.addEventListener('click', () => remove(panel, button.dataset.knowfitTestRemove));
      });
      render(panel);
    });
  }

  window.KnowFitTestCatalogUI = { initialize };
  window.addEventListener('knowfit:test-catalog-change', refresh);
  window.addEventListener('storage', (event) => {
    if (event.key === null || event.key === window.KnowFitTestCatalog?.STORAGE_KEY) refresh();
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
})();
